import React,{Fragment} from 'react'

const Weather = ({result,saveLoading}) => {
    let resultArray=[]
    saveLoading(false)
   
    let currentTemp=0
    let tempMax=0
    let tempMin=0
    
    if(Object.entries(result).length>0){
    const {name, main:{temp, temp_max, temp_min}}= result
    const key=Date.now()
    
    currentTemp = convertKelvintoCent(temp);
    tempMax = convertKelvintoCent(temp_max);
    tempMin = convertKelvintoCent(temp_min);

    function convertKelvintoCent(temp){
        return parseInt(temp - 273.15);
    }

    resultArray.push(
        <div className="text-center text-white mt-5" key={key}>
                <p className="font-bold text-2xl">El clima en {name}</p>
                <p className="font-bold text-6xl"> {currentTemp}&deg;C </p>
                <p className="font-bold text-xl"> {tempMax}&deg;C  Max</p>
                <p className="font-bold text-xl"> {tempMin}&deg;C  Min</p>
        </div>
    )
}
    return ( 
         <Fragment>
            {resultArray}
         </Fragment>   
        
     );
}
 
export default Weather;